/* "· dados de exemplo" next to the page title while the panel shows example data. */
export function ExampleBadge({ show }: { show: boolean }) {
    if (!show) return null
    return (
        <span title="Dados de exemplo: o painel ainda não lê os sistemas reais" className="text-[12px] font-medium text-muted">
            · dados de exemplo
        </span>
    )
}
